import React, {
	forwardRef,
	SelectHTMLAttributes,
	OptionHTMLAttributes,
} from 'react'
import clsx from 'clsx'
import { Input } from '../Input'
import './index.scss'

export const DropdownContainer = Input.Container
export const DropdownLabel = Input.Label
export const DropdownDescription = Input.Description
export const DropdownError = Input.Error

export function DropdownOption({
	className,
	...rest
}: OptionHTMLAttributes<HTMLOptionElement>) {
	return <option className={clsx('', className)} {...rest} />
}

export const DropdownField = forwardRef<
	HTMLSelectElement,
	SelectHTMLAttributes<HTMLSelectElement>
>(function ({ className, ...rest }, ref) {
	return (
		<select
			className={clsx('input-field', 'dropdown-field', className)}
			{...rest}
			ref={ref}></select>
	)
})

/**
 * @example Usage
<Dropwdown.Container>
  <Dropwdown.Label>Fo Label</Dropwdown.Label>
  <Dropwdown.Field>
    <Dropwdown.Option>fo</Dropwdown.Option>
    <Dropwdown.Option>bar</Dropwdown.Option>
  </Dropwdown.Field>
  <Dropwdown.Description>Fo Description</Dropwdown.Description>
</Dropwdown.Container>
 */
export const Dropdown = {
	Container: DropdownContainer,
	Label: DropdownLabel,
	Field: DropdownField,
	Description: DropdownDescription,
	Error: DropdownError,
	Option: DropdownOption,
}
